<section class="flex h-full flex-col gap-4">
  <section class="border border-neutral-20 px-4 py-4">
    <label for="outlook-calendar-sync-toggle" class="flex items-center gap-3">
      <span
        class="inline-flex"
        kendoTooltip
        position="top"
        [title]="'outlookSync.calendar.syncDirectionTooltip' | translate"
      >
        <kendo-switch
          id="outlook-calendar-sync-toggle"
          [formControl]="form().controls.appointmentsSyncEnabled"
        ></kendo-switch>
      </span>
      <span class="font-semibold text-component-text">
        {{ 'outlookSync.calendar.syncTitle' | translate }}
      </span>
    </label>

    <p class="mt-2 text-sm text-component-text">
      <strong>{{ 'outlookSync.syncDirection.label' | translate }}</strong>
      {{ 'outlookSync.calendar.syncDirection' | translate }}
    </p>

    @if (showRollingWindowDaysAfter) {
      <label
        for="outlook-calendar-sync-up-to"
        class="mt-3 flex flex-col gap-1.5"
      >
        <span class="text-sm font-semibold text-component-text">
          {{ 'outlookSync.calendar.syncUpToLabel' | translate }}
        </span>
        <kendo-dropdownlist
          id="outlook-calendar-sync-up-to"
          class="w-36"
          [data]="syncUpToOptions"
          [valuePrimitive]="true"
          [formControl]="form().controls.appointmentsRollingWindowDaysAfter"
        >
          <ng-template kendoDropDownListValueTemplate let-dataItem>
            {{
              'outlookSync.calendar.syncUpToOption'
                | translate: { days: dataItem }
            }}
          </ng-template>
          <ng-template kendoDropDownListItemTemplate let-dataItem>
            {{
              'outlookSync.calendar.syncUpToOption'
                | translate: { days: dataItem }
            }}
          </ng-template>
        </kendo-dropdownlist>
      </label>
    }

    <p class="mt-3 flex items-center gap-2 text-sm text-neutral-70">
      <span class="fa-icons icon-10 icon-circle-info" aria-hidden="true"></span>
      {{
        'outlookSync.calendar.note'
          | translate
            : {
                daysBack: syncFrequency.daysBack,
                daysAfter: daysAfter(),
                minutes: syncFrequency.intervalMinutes,
              }
      }}
    </p>
  </section>

  <maximizer-history-grid
    [history]="history()"
    [loading]="historyLoading()"
    [showIgnored]="true"
    [boxed]="false"
    (refresh)="refreshHistory()"
  ></maximizer-history-grid>
</section>
